import * as React from "react";
import { BarChart, Box } from "@amzn/awsui-components-react";
import { Funding } from "../../../calcBusterTypes";
import { USDollar } from "../../../util";

const EligibleServicesBarChart: React.FC<{ funding: Funding }> = ({
  funding,
}) => {
  const chartData = React.useMemo(() => {
    const mapTotalARR = funding.annualRunRate;
    const mapEligibleARR =
      funding.map?.mobilizeAndMigrate?.eligibleAnnualRunRate ?? 0;
    const sapEligibleARR =
      funding.map?.mobilizeAndMigrate?.credits?.sapAndOracle
        ?.eligibleAnnualRunRate ?? 0;
    const dbAnalyticsEligibleARR =
      funding.map?.mobilizeAndMigrate?.credits?.dbAndAnalytics
        ?.eligibleAnnualRunRate ?? 0;

    return [
      {
        title: "Total Annual Run Rate",
        type: "bar" as const,
        valueFormatter: (value: number) => USDollar.format(value),
        data: [
          { x: "MAP Standard", y: mapTotalARR },
          ...(sapEligibleARR > 0 ? [{ x: "SAP/Oracle", y: mapTotalARR }] : []),
          ...(dbAnalyticsEligibleARR > 0
            ? [{ x: "DB & Analytics", y: mapTotalARR }]
            : []),
        ],
      },
      {
        title: "Eligible Annual Run Rate",
        type: "bar" as const,
        valueFormatter: (value: number) => USDollar.format(value),
        data: [
          { x: "MAP Standard", y: mapEligibleARR },
          ...(sapEligibleARR > 0
            ? [{ x: "SAP/Oracle", y: sapEligibleARR }]
            : []),
          ...(dbAnalyticsEligibleARR > 0
            ? [{ x: "DB & Analytics", y: dbAnalyticsEligibleARR }]
            : []),
        ],
      },
    ];
  }, [funding]);

  return (
    <BarChart
      series={chartData}
      xTitle="Categories"
      yTitle="Annual Run Rate (USD)"
      hideFilter
      height={200}
      loadingText="Loading chart"
      statusType="finished"
      emphasizeBaselineAxis
      stackedBars={false}
      horizontalBars
      empty={
        <Box textAlign="center" color="inherit">
          <b>No data available</b>
          <Box variant="p" color="inherit">
            There is no services data available
          </Box>
        </Box>
      }
      ariaLabel="Eligible Services Annual Run Rate Comparison"
      i18nStrings={{
        filterLabel: "Filter displayed data",
        filterPlaceholder: "Filter data",
        filterSelectedAriaLabel: "selected",
        legendAriaLabel: "Legend",
        chartAriaRoleDescription: "bar chart",
        xAxisAriaRoleDescription: "x axis",
        yAxisAriaRoleDescription: "y axis",
      }}
      xScaleType="categorical"
      yScaleType="linear"
    />
  );
};

export default EligibleServicesBarChart;
